import { render } from "./Index.vue?vue&type=template&id=edd001ec&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=edd001ec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-edd001ec"

export default script